var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 65 65",
    width: "65pt",
    height: "65pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_PequWIP0L4LVFedgfoG2gx2WPiEOwFX5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_PequWIP0L4LVFedgfoG2gx2WPiEOwFX5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 59.802 0 L 5.554 0 C 2.591 0 0 2.133 0 5.063 L 0 59.43 C 0 62.376 2.591 65 5.554 65 L 59.785 65 C 62.765 65 65 62.359 65 59.43 L 65 5.063 C 65.017 2.133 62.765 0 59.802 0 Z  M 20.148 54.181 L 10.836 54.181 L 10.836 25.228 L 20.148 25.228 L 20.148 54.181 Z  M 15.814 20.826 L 15.746 20.826 C 12.766 20.826 10.836 18.608 10.836 15.831 C 10.836 13.003 12.817 10.836 15.865 10.836 C 18.912 10.836 20.775 12.986 20.843 15.831 C 20.843 18.608 18.912 20.826 15.814 20.826 Z  M 54.181 54.181 L 44.868 54.181 L 44.868 38.35 C 44.868 34.557 43.514 31.967 40.145 31.967 C 37.571 31.967 36.047 33.711 35.37 35.404 C 35.116 36.013 35.048 36.843 35.048 37.689 L 35.048 54.181 L 25.736 54.181 L 25.736 25.228 L 35.048 25.228 L 35.048 29.258 C 36.403 27.327 38.519 24.551 43.446 24.551 C 49.558 24.551 54.181 28.58 54.181 37.266 L 54.181 54.181 L 54.181 54.181 Z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a98df04e5d6cffe2c3436fe25a66d220.svg";
export { ForwardRef as ReactComponent };